import { GalleryBrowser, type GalleryItem } from '../GalleryBrowser';
import { BottomSheet } from './BottomSheet';

export function GallerySheet({
  apiBase,
  storeId = 'ox',
  onClose,
  onPickArtwork,
}: {
  apiBase: string;
  storeId?: string;
  onClose: () => void;
  onPickArtwork: (item: GalleryItem) => Promise<void>;
}) {
  return (
    <BottomSheet title="Galería" onClose={onClose} tall>
      <GalleryBrowser
        apiBase={apiBase}
        storeId={storeId}
        onPickArtwork={async (item) => {
          await onPickArtwork(item);
          onClose();
        }}
      />
    </BottomSheet>
  );
}
